import React, { FC } from 'react'
import { Flex, Skeleton } from 'antd'
import { LockOutlined } from '@ant-design/icons'
import { EmptyState, Well } from '@pushly/aqe/lib/components'
import { useService } from '@pushly/aqe/lib/hooks/use-service'
import { domainHasFlag } from '../constants'
import { BrandVoiceWell } from './brand-voice-well'
import { FEAT_PUSHLY_AI } from '../../../constants'
import { AbilityAction } from '../../../enums/ability-action.enum'
import { AppState } from '../../../stores/app'
import { DomainDto } from '../../../dtos/domain'
import { VERTICAL_WELL_GAP } from '../../../theme/constants'
import { getClassNames } from '../../../_utils/classnames'

interface IBrandVoiceSettings {
    loading: boolean
    domain?: DomainDto
}

export const BrandVoiceSettings: FC<IBrandVoiceSettings> = ({ loading, domain }) => {
    const appState = useService(AppState)
    const enabled = domainHasFlag(domain, FEAT_PUSHLY_AI)
    const canEdit = !!domain && appState.abilityStore.can(AbilityAction.UPDATE, domain)

    return (
        <Flex vertical gap={VERTICAL_WELL_GAP} className={getClassNames('brand-voice-settings')}>
            {enabled ? (
                !loading && domain && <BrandVoiceWell domain={domain} canEdit={canEdit} enabled={enabled} />
            ) : (
                <Well title="Brand Voice" footerMode="hidden">
                    <Skeleton loading={loading} active={true} title={false}>
                        <EmptyState
                            icon={<LockOutlined />}
                            iconVariant="chip"
                            title="Brand Voice is not enabled for this domain"
                            description="Talk to your account admin about applying your editorial standards to everything Pushly AI writes."
                        />
                    </Skeleton>
                </Well>
            )}
        </Flex>
    )
}
